import { ArticleHeading0, ArticleHeading1, ArticleHeading2, ArticleHeading3, ArticleHeading4, ArticleHeading5, ArticleHeading6 } from '../Article/ArticleHeading';

/**
 * @deprecated используйте ArticleHeading0 или UIHeading0
 */
export var Header0 = ArticleHeading0;

/**
 * @deprecated используйте ArticleHeading1 или UIHeading1
 */
export var Header1 = ArticleHeading1;

/**
 * @deprecated используйте ArticleHeading2 или UIHeading2
 */
export var Header2 = ArticleHeading2;

/**
 * @deprecated используйте ArticleHeading3 или UIHeading3
 */
export var Header3 = ArticleHeading3;

/**
 * @deprecated используйте ArticleHeading4 или UIHeading4
 */
export var Header4 = ArticleHeading4;

/**
 * @deprecated используйте ArticleHeading5 или UIHeading5
 */
export var Header5 = ArticleHeading5;

/**
 * @deprecated используйте ArticleHeading6 или UIHeading6
 */
export var Header6 = ArticleHeading6;